import { DEFAULT_EVENT_VALUES, EARLY_JOIN_WINDOW_MINUTES } from "%/constants/event-constants";
import {
  END_MODE_ON,
  buildRRule,
  parseRRule,
  ruleToSave,
} from "%/utils/recurrence-rule";

export const getBrowserTimezone = () => {
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return timezone || "";
  } catch (error) {
    return "";
  }
};

export const createDefaultEvent = () => ({
  ...DEFAULT_EVENT_VALUES,
  eventTimestamp: Math.round(Date.now() / 1000),
});

export const getStartTimestamp = event => {
  if (!event) {
    return 0;
  }

  const eventDate = new Date(event.eventTimestamp * 1000);

  if (event.isAllDay) {
    eventDate.setHours(0, 0, 0, 0);
    return Math.floor(eventDate.getTime() / 1000);
  }

  const [hours, minutes] = String(event.startTime || "09:00").split(":");

  eventDate.setHours(parseInt(hours, 10), parseInt(minutes, 10), 0, 0);

  return Math.floor(eventDate.getTime() / 1000);
};

export const getEndTimestamp = event => {
  if (!event) {
    return 0;
  }

  const eventDate = new Date(event.eventTimestamp * 1000);

  if (event.isAllDay) {
    eventDate.setHours(23, 59, 59, 0);
    return Math.floor(eventDate.getTime() / 1000);
  }

  const [hours, minutes] = String(event.endTime || "17:00").split(":");

  eventDate.setHours(parseInt(hours, 10), parseInt(minutes, 10), 0, 0);

  return Math.floor(eventDate.getTime() / 1000);
};

export const isRecurringEvent = event => Boolean(event && event.recurrenceRule);

export const getEventRRule = event => {
  if (!isRecurringEvent(event)) {
    return "";
  }

  return ruleToSave(
    event.rrule,
    event.recurrenceRule,
    Number(event.seriesEventTimestamp || event.eventTimestamp) || 0,
  );
};

export const getRecurringEndTimestamp = event => {
  if (!isRecurringEvent(event)) {
    return 0;
  }

  const { end } = event.recurrenceRule;

  return end && end.mode === END_MODE_ON ? end.until : 0;
};

export const validateEventRecurrence = event => {
  if (!isRecurringEvent(event)) {
    return "";
  }

  try {
    buildRRule(event.recurrenceRule);
  } catch (error) {
    return error.message;
  }

  const { end } = event.recurrenceRule;

  if (end.mode === END_MODE_ON && end.until <= Number(event.eventTimestamp)) {
    return "The date this event stops repeating has to be after the event itself";
  }

  return "";
};

export const readEventRecurrence = event => {
  const rrule = event && event.rrule ? String(event.rrule).trim() : "";

  if (rrule === "") {
    return null;
  }

  return parseRRule(rrule, Number(event.seriesEventTimestamp || event.eventTimestamp) || 0);
};

export const getEarlyJoinMinutes = event => {
  if (!event || !event.allowEarlyJoin) {
    return 0;
  }

  return EARLY_JOIN_WINDOW_MINUTES;
};
